//? GLOBAL
window.firstHit = true;
window.readyDelay = 0.1;
window.readyCallbackDelay = 0.2;

//! Alpine
import Alpine from 'alpinejs';
window.Alpine = Alpine;

//? Alpine Datas
import xDatasApp from './alpine-datas/xDatasApp';
Alpine.data('DatasApp', xDatasApp);

import DOMFxEvents from './alpine-datas/xDatasFxEvents';
Alpine.data('DOMFxEvents', DOMFxEvents);

import Navigation from './modules/Navigation';
Alpine.data('Navigation', Navigation);

import Cart from './modules/CartDrawer';
Alpine.data('CartDrawer', Cart);

//? BASE
import BrowserDetection from './base/detection.js';
import Env from './base/env.js';
import Channels from './base/channels.js';

//? TRANSITIONS
// import { EmbraceTheFlame } from './transition/Nexus';

//? LAYOUT SETUP
import ResizeDebounce from './utils/ResizeDebounce';
import HashEmitter from './utils/HashEmitter';
import UI from './ui/Setup.js';
import Launcher from './modules/Launcher.js';

//? MODULES
import * as modules from './modules';
import modular from 'modujs';
window.app = new modular({
  modules: modules,
});

//? INIT
document.addEventListener('DOMContentLoaded', function () {
  //? Starter
  new BrowserDetection();
  ResizeDebounce();
  //? Detect hashchange
  HashEmitter();
  //? Views
  new Launcher();
  window.UI = new UI();
  //! New Game +
  app.init(app);
  // EmbraceTheFlame();

  if (window.location.href.includes('http://127.0.0.1:9292')) {
    console.log('oror');
    Env.$html.classList.add('local-env');
  }

  //? Signature
  console.log(
    '\n%cMade with ❤️ by Index: https://index.studio — 💻 Dev by JCS https://www.jcsuzanne.com',
    'color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0.3rem auto 1.3rem auto; font-family: Metropolis, Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#000, #122), radial-gradient(circle at top left, #54E5E3, #ED1E63);background-origin: border-box;background-clip: padding-box, border-box;'
  );
  //? PWA
  if (config.env === 'production') {
    navigator.serviceWorker.controller
      ? console.log(
          '[PWA Builder] active service worker found, no need to register'
        )
      : navigator.serviceWorker
          .register(config.pathRoot + 'pwa.js', { scope: config.pathRoot })
          .then(function (e) {
            console.log(
              'Service worker has been registered for scope:' + e.scope
            );
          });
  }
});
Alpine.start();
